/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./ubl-link.component";
import * as i2 from "@angular/router";
var styles_UblLinkComponent = [];
var RenderType_UblLinkComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_UblLinkComponent, data: {} });
export { RenderType_UblLinkComponent as RenderType_UblLinkComponent };
export function View_UblLinkComponent_0(_l) { return i0.ɵvid(0, [i0.ɵncd(null, 0)], null, null); }
export function View_UblLinkComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "a", [["ubl-link", ""]], null, null, null, View_UblLinkComponent_0, RenderType_UblLinkComponent)), i0.ɵdid(1, 245760, null, 0, i1.UblLinkComponent, [i0.ElementRef, i2.Router], { type: [0, "type"] }, null)], function (_ck, _v) { var currVal_0 = ""; _ck(_v, 1, 0, currVal_0); }, null); }
var UblLinkComponentNgFactory = i0.ɵccf("a[ubl-link]", i1.UblLinkComponent, View_UblLinkComponent_Host_0, { type: "ubl-link", target: "ubl-link-target" }, {}, ["*"]);
export { UblLinkComponentNgFactory as UblLinkComponentNgFactory };
